import type { Project } from '@littlebird/sdk';

export const getOtherMembers = <T extends { userId: number | null }>(
  members: readonly T[] | undefined,
  currentUserId: string | undefined
): T[] =>
  (members ?? []).filter((member) => String(member.userId) !== currentUserId);

export const isProjectPrivate = (
  project: Project,
  others: readonly { userId: number | null }[]
) => others.length === 0 && !project.hasShareLink;

export const getProjectTeamName = (member: { displayName: string | null }) =>
  member.displayName ?? 'Team';
